import {CardBody} from '../card-features/CardBody';
import {CardHeader} from '../card-features/CardHeader';

export const conditionCardSize = (size) => {
    if (size === 'sm') {
        return `
        ${CardBody},
        ${CardHeader} {
                padding: var(--space-sm);
            }
        `;
    }
};
